// An in-memory store used specifically for the 'persisting' of the remail when
// navigating between the LoginForm's Email, Register, Forgot and MagicLink forms
// (while avoiding the use of localStorage or sessionStorage). Refreshing the page
// entirely will still clear the email, but navigating between forms wont.
let lastEmail = '';

export function setLastEmail(email: string): void {
  lastEmail = email || '';
}

export function getLastEmail(): string {
  return lastEmail;
}
